import { useCallback, useRef, useState } from "react";
import eligibilityCheckServices from "../../../../services/api/service/eligibilityCheckService";

export function useBulkUpload({
  submissionTrackingId,
}: {
  submissionTrackingId: any;
}) {
  const [countBulkUpload, setCountBulkUpload] = useState<number>(0);
  const [isBulkUploadModalOpen, setIsBulkUploadModalOpen] = useState(false);
  const lastCountTrackingIdRef = useRef<any>(null);

  const handleDocCount = useCallback(async (trackingId: any, opts?: { force?: boolean }) => {
    if (!opts?.force && lastCountTrackingIdRef.current === trackingId) return;
    lastCountTrackingIdRef.current = trackingId;
    try {
      const result = await eligibilityCheckServices.bulkDocumentCount({
        trackingId,
      });
      if (result?.status === 200) {
        setCountBulkUpload(result?.data?.data?.count ?? 0);
      }
    } catch {
      // ignore
    }
  }, []);

  const openBulkUploadModal = useCallback(() => {
    setIsBulkUploadModalOpen(true);
  }, []);

  const closeBulkUploadModal = useCallback(() => {
    handleDocCount(submissionTrackingId, { force: true });
    setIsBulkUploadModalOpen(false);
  }, [handleDocCount, submissionTrackingId]);

  const handleContinueBulkUpload = useCallback(
    (_files: any[]) => {
      handleDocCount(submissionTrackingId, { force: true });
      closeBulkUploadModal();
    },
    [handleDocCount, submissionTrackingId, closeBulkUploadModal]
  );

  return {
    countBulkUpload,
    isBulkUploadModalOpen,
    openBulkUploadModal,
    closeBulkUploadModal,
    handleContinueBulkUpload,
    handleDocCount,
  };
}

